export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/759325b6233e00950be09763e38e76e0.jpg" 
          alt="Professional Interlocked Driveway" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-purple-900/60 via-purple-900/40 to-green-900/50"></div>
      </div>
      
      <div className="relative z-10 text-center px-4 sm:px-6 max-w-6xl mx-auto w-full">
        <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl font-bold text-white mb-4 sm:mb-6 md:mb-8 lg:mb-10 leading-tight break-words">
          Transform Your Outdoor Space
        </h1>
        <p className="text-base xs:text-lg sm:text-xl md:text-2xl lg:text-4xl xl:text-5xl text-white/95 mb-6 sm:mb-8 md:mb-10 lg:mb-12 max-w-4xl mx-auto font-semibold break-words">
          Expert hardscape solutions for driveways, patios, and flower beds. Quality craftsmanship you can trust.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-6 justify-center items-center">
          <button 
            onClick={scrollToContact}
            className="bg-green-600 text-white px-6 xs:px-8 sm:px-12 md:px-16 py-3 xs:py-4 sm:py-6 md:py-8 rounded-xl sm:rounded-2xl text-base xs:text-lg sm:text-2xl md:text-3xl font-bold hover:bg-green-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl w-full sm:w-auto max-w-xs sm:max-w-none"
          >
            Get Free Estimate
          </button>
          <button 
            onClick={() => {
              const element = document.getElementById('portfolio');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            }}
            className="bg-purple-600 text-white px-6 xs:px-8 sm:px-12 md:px-16 py-3 xs:py-4 sm:py-6 md:py-8 rounded-xl sm:rounded-2xl text-base xs:text-lg sm:text-2xl md:text-3xl font-bold hover:bg-purple-700 transition-all whitespace-nowrap cursor-pointer shadow-2xl w-full sm:w-auto max-w-xs sm:max-w-none"
          >
            View Our Work
          </button>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}